/* eslint-disable import/no-anonymous-default-export */
const SESSION_KEY = "app_session";

class SessionService {
  memory = null;

  constructor() {
    this.load();
  }

  load() {
    const raw = localStorage.getItem(SESSION_KEY);
    if (raw) this.memory = JSON.parse(raw);
  }

  setSession({ accessToken, refreshToken, user }) {
    this.memory = { accessToken, refreshToken, user };
    localStorage.setItem(SESSION_KEY, JSON.stringify(this.memory));
  }

  updateAccessToken(accessToken, refreshToken) {
    if (!this.memory) return;
    this.memory.accessToken = accessToken;
    if (refreshToken) this.memory.refreshToken = refreshToken;
    localStorage.setItem(SESSION_KEY, JSON.stringify(this.memory));
  }

  clear() {
    this.memory = null;
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem("cart");
    localStorage.removeItem("guestCart");
  }

  get accessToken() {
    return this.memory?.accessToken || null;
  }

  get refreshToken() {
    return this.memory?.refreshToken || null;
  }

  get user() {
    return this.memory?.user || null;
  }

  get isLoggedIn() {
    return Boolean(this.memory?.accessToken);
  }
}

export default new SessionService();
